window.log = console.log;
if(!window.console) {console={}; console.log=function(){}; log=function(){};}

export default log;